import axios from'../axios';var globalVar=window._env_;var serverService={/**
     * lấy số lượng kết nối tới server
     */getConnectionCount:function getConnectionCount(){return axios.get(globalVar.api.API_BASE_URL+'realtime/connectioninfo/connection');},/**
     * Lấy thông tin  liên hệ
     * @returns 
     */getContactInfo:function getContactInfo(){return axios.get(globalVar.api.API_BASE_URL+'sso/info/getFooterLink');},/**
     * Lấy footerlink
     * @returns 
     */getFooterLink:function getFooterLink(){return axios.get(globalVar.api.API_BASE_URL+'sso/info/getFooterLink');}};export default serverService;